module.exports = __webpack_public_path__ + "img/ar.5ab0fbbe.svg";